import { HttpInterceptorFn } from '@angular/common/http';

import { authInterceptor as izaAuthInterceptor } from './auth-interceptor';
import { autosyncInterceptor as izaAutosyncInterceptor } from './autosync-interceptor';
import { auth0ErrorInterceptor as izaAuth0ErrorInterceptor } from './auth0-error-interceptor';

export const IZA_INTERCEPTORS: HttpInterceptorFn[] = [
  izaAuthInterceptor,
  izaAutosyncInterceptor,
  izaAuth0ErrorInterceptor,
];
